import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  min-height: 280px;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .chart {
    flex: 1;
  }

  .not-data {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    color: #9ca3af;
    font-size: 0.9rem;
    text-align: center;
    padding: 0 1rem;
  }

  .not-data.error {
    color: #dc2626;
  }
`;

export const TooltipCard = styled.div`
  background: #111827;
  color: #fff;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .name {
    font-weight: 700;
  }
`;
